export interface Comic {
  id: string;
  title: string;
  author: string;
  categories: string[];
  status: "连载中" | "已完结";
  region: string;
  year: number;
  updatedAt: string;
  views: number;
  follows: number;
  score: number;
  cover: string;
  tagline: string;
  intro: string;
  chapters: number;
  files: { label: string; size: string; format: string }[];
  tags: string[];
  color: string;
}

export const CATEGORIES = [
  { key: "hot-blood", name: "热血", en: "Hot Blood", desc: "战斗、成长与信念，一场接一场的高燃对决。", icon: "ri-fire-line" },
  { key: "romance", name: "恋爱", en: "Romance", desc: "心动、错过与重逢，把青春写成一场浪漫。", icon: "ri-heart-3-line" },
  { key: "fantasy", name: "奇幻", en: "Fantasy", desc: "异世界、魔法与古神传说，翻开另一个宇宙。", icon: "ri-magic-line" },
  { key: "mystery", name: "悬疑", en: "Mystery", desc: "密室、诡计与反转，猜到最后也猜不到结局。", icon: "ri-search-eye-line" },
  { key: "sci-fi", name: "科幻", en: "Sci-Fi", desc: "机甲、星舰与赛博废墟，人类未来的另一种想象。", icon: "ri-planet-line" },
  { key: "healing", name: "治愈", en: "Healing", desc: "小镇、猫与便当，一天里最温柔的十五分钟。", icon: "ri-plant-line" },
  { key: "action", name: "动作", en: "Action", desc: "刀光、追击与分镜爆发，肾上腺素全程拉满。", icon: "ri-sword-line" },
  { key: "comedy", name: "搞笑", en: "Comedy", desc: "吐槽、沙雕与全员疯批，笑到合不拢嘴。", icon: "ri-emotion-laugh-line" },
];

export const REGIONS = ["日本", "国漫", "韩国", "欧美"];

export const YEARS = [2026, 2025, 2024, 2023, 2022];

export const COMICS: Comic[] = [
  {
    id: "chiyan-juexing",
    title: "赤焰觉醒",
    author: "夜见川",
    categories: ["热血", "动作"],
    status: "连载中",
    region: "日本",
    year: 2026,
    updatedAt: "2026-10-16",
    views: 1284000,
    follows: 86400,
    score: 9.4,
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20cover%20of%20a%20young%20swordsman%20with%20glowing%20crimson%20flames%20swirling%20around%20his%20blade%2C%20dark%20violet%20night%20sky%20background%20with%20ember%20sparks%2C%20dramatic%20rim%20lighting%2C%20high%20contrast%20illustration%2C%20clean%20vignette%20composition%2C%20no%20text&width=600&height=840&seq=comic-cover-chiyan&orientation=portrait",
    tagline: "少年以火焰为剑，向被神明抛弃的城市挥出第一击。",
    intro: "在被“灰烬之神”统治的都市里，普通人只能以沉默换生存。十七岁的临焰偶然觉醒了被禁止的赤焰之力，从此被卷入地下反抗组织与神廷之间的漫长战争。他必须在守护身边人、揭开自身身世秘密与抵抗神权之间做出选择。热血、羁绊与代价交织的长篇连载，战斗分镜被誉为近年最富冲击力的作品之一。",
    chapters: 128,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "1.42 GB", format: "PDF" },
      { label: "单话打包 · 第 001-128 话", size: "986 MB", format: "CBZ" },
      { label: "手机竖屏优化版", size: "642 MB", format: "ZIP" },
    ],
    tags: ["少年漫", "战斗", "异能", "成长"],
    color: "from-accent-600 to-primary-700",
  },
  {
    id: "xinghe-qingnian",
    title: "星河里的你",
    author: "早川铃",
    categories: ["恋爱", "治愈"],
    status: "连载中",
    region: "日本",
    year: 2025,
    updatedAt: "2026-10-17",
    views: 962000,
    follows: 71200,
    score: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20of%20a%20girl%20and%20boy%20standing%20under%20a%20starry%20sky%20by%20the%20ocean%2C%20soft%20pink%20and%20violet%20gradient%20sky%2C%20fireflies%20and%20meteor%20shower%2C%20gentle%20glowing%20light%2C%20clean%20stylized%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-xinghe&orientation=portrait",
    tagline: "天文社的夏夜，观测记录里写满了另一个人的名字。",
    intro: "转学生星野澪加入了只剩两个人的天文社，与社长夏川遥一起守着一台快要报废的望远镜。他们在每个晴夜记录星轨，也在记录彼此不提出口的心事。随着毕业与离别逼近，两人终于不得不面对那颗一直被绕开的“行星”。细腻分镜与季节感的底色，是本年度最受欢迎的青春恋爱长篇。",
    chapters: 76,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "892 MB", format: "PDF" },
      { label: "单话打包 · 第 001-076 话", size: "534 MB", format: "CBZ" },
    ],
    tags: ["校园", "青春", "治愈系", "天文社"],
    color: "from-secondary-500 to-primary-600",
  },
  {
    id: "weiye-wangzhe",
    title: "雾夜王座",
    author: "白鸦工作室",
    categories: ["奇幻", "悬疑"],
    status: "连载中",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-15",
    views: 875000,
    follows: 65900,
    score: 9.3,
    cover: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20with%20a%20hooded%20figure%20holding%20an%20ornate%20lantern%20in%20a%20misty%20gothic%20city%2C%20deep%20indigo%20and%20amber%20lighting%2C%20crows%20and%20fog%2C%20intricate%20detail%2C%20mysterious%20atmosphere%2C%20no%20text&width=600&height=840&seq=comic-cover-wuye&orientation=portrait",
    tagline: "王座空悬三百年，而雾里有人在数着登基的台阶。",
    intro: "雾夜王国每三十年只开一次城门，凡是走进王宫的人，都会在第七夜之前失去身份。落魄的记录官褚白为了寻找失踪的妹妹，带着半张残破的地图闯入王座之城，却发现所谓的加冕仪式，其实是一场精心设计的献祭。层层嵌套的诡计与东方审美的画面，让这部国漫在连载初期就冲上榜首。",
    chapters: 94,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "1.18 GB", format: "PDF" },
      { label: "章节合集 · 第 001-094 话", size: "745 MB", format: "CBZ" },
      { label: "设定集附录", size: "218 MB", format: "ZIP" },
    ],
    tags: ["国漫", "悬疑", "东方奇幻", "诡计"],
    color: "from-primary-700 to-secondary-700",
  },
  {
    id: "jijia-daihao-07",
    title: "机甲代号07",
    author: "零号工房",
    categories: ["科幻", "动作"],
    status: "已完结",
    region: "韩国",
    year: 2024,
    updatedAt: "2026-09-28",
    views: 1420000,
    follows: 98300,
    score: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20mecha%20manga%20cover%20of%20a%20tall%20humanoid%20robot%20in%20a%20neon%20ruined%20city%2C%20cyan%20and%20amber%20accent%20lights%2C%20rainy%20atmosphere%2C%20bold%20graphic%20composition%2C%20detailed%20mechanical%20panels%2C%20no%20text&width=600&height=840&seq=comic-cover-jijia&orientation=portrait",
    tagline: "最后一台没有驾驶员的机甲，自己学会了战斗。",
    intro: "第七次殖民战争后，人类把战线交给了自主机甲。代号 07 的机体在一次战役中失去了全部驾驶员，却开始自行行动。维修少女林砚被派去接管这台“故障机”，却逐渐发现它的核心记录里藏着战争真正的起点。已完结的 210 话完整收录，结局被读者称为“把科幻写成了诗”。",
    chapters: 210,
    files: [
      { label: "完结全集 · 高清 PDF", size: "2.36 GB", format: "PDF" },
      { label: "完结全集 · 图片包", size: "1.64 GB", format: "CBZ" },
      { label: "画集与设定资料", size: "486 MB", format: "ZIP" },
    ],
    tags: ["机甲", "战争", "科幻", "完结"],
    color: "from-primary-600 to-background-800",
  },
  {
    id: "banlu-chafang",
    title: "半路茶房",
    author: "千叶慢慢",
    categories: ["治愈", "恋爱"],
    status: "连载中",
    region: "日本",
    year: 2025,
    updatedAt: "2026-10-12",
    views: 631000,
    follows: 48200,
    score: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20slice%20of%20life%20anime%20manga%20cover%20of%20a%20warm%20traditional%20tea%20house%20with%20steaming%20cups%2C%20hanging%20lanterns%2C%20autumn%20leaves%2C%20a%20cat%20sleeping%20on%20the%20counter%2C%20soft%20amber%20and%20cream%20lighting%2C%20gentle%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-chafang&orientation=portrait",
    tagline: "山路的尽头有一间茶房，只招呼走累了的人。",
    intro: "在通往山顶的旧国道旁，有一间没有招牌的茶房。老板娘只做三种点心，却记得每位客人最疲惫的那句话。第 5 话起加入了一位定期来复习考试的大学生，两人的交流从一杯冷掉的茶慢慢变成彼此生活的支点。适合睡前读的温柔日常系作品。",
    chapters: 58,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "640 MB", format: "PDF" },
      { label: "单话打包 · 第 001-058 话", size: "398 MB", format: "CBZ" },
    ],
    tags: ["日常", "美食", "慢生活", "猫"],
    color: "from-accent-500 to-secondary-600",
  },
  {
    id: "shisan-hao-mishi",
    title: "十三号密室",
    author: "顾南舟",
    categories: ["悬疑", "动作"],
    status: "连载中",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-14",
    views: 1103000,
    follows: 82700,
    score: 9.2,
    cover: "https://readdy.ai/api/search-image?query=Tense%20thriller%20manga%20cover%20of%20a%20dim%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20silhouette%20of%20a%20detective%2C%20scattered%20files%20and%20a%20key%20on%20the%20table%2C%20moody%20deep%20purple%20shadows%2C%20dramatic%20lighting%2C%20no%20text&width=600&height=840&seq=comic-cover-mishi&orientation=portrait",
    tagline: "每个进过十三号密室的人，都给出了不一样的描述。",
    intro: "重案组接连收到十二起“无凶手”案件的报告，唯一的共同点，是现场都出现了同一把铜钥匙。犯罪心理学顾问沈砚接手调查后，发现自己童年记忆中的那间屋子，与案件现场完全一致。作品以严格的推理结构著称，每十话一次推理复盘，读者可自行解谜。",
    chapters: 66,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "1.05 GB", format: "PDF" },
      { label: "章节合集 · 第 001-066 话", size: "688 MB", format: "CBZ" },
    ],
    tags: ["推理", "刑侦", "悬疑", "烧脑"],
    color: "from-primary-800 to-background-800",
  },
  {
    id: "jiandao-liulang",
    title: "剑道流浪帖",
    author: "北野寺",
    categories: ["热血", "动作"],
    status: "已完结",
    region: "日本",
    year: 2023,
    updatedAt: "2026-08-30",
    views: 1560000,
    follows: 104000,
    score: 9.5,
    cover: "https://readdy.ai/api/search-image?query=Samurai%20manga%20cover%20of%20a%20wandering%20swordsman%20walking%20through%20a%20bamboo%20forest%20at%20sunset%2C%20orange%20sky%20and%20long%20shadows%2C%20worn%20kimono%2C%20katana%20on%20back%2C%20ink%20style%20brush%20texture%2C%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=comic-cover-jiandao&orientation=portrait",
    tagline: "刀不出鞘的人，才最让人害怕。",
    intro: "浪人千鸟无鞘走遍四国，只为找到二十年前灭门之夜唯一活下来的那个孩子。一路遇到的山贼、官差、旧友与仇敌，都在逼他重新拔刀。全 186 话完结，被誉为近十年最完整的剑戟题材长篇，战斗场面全部分镜手绘完成。",
    chapters: 186,
    files: [
      { label: "完结全集 · 高清 PDF", size: "2.04 GB", format: "PDF" },
      { label: "完结全集 · 图片包", size: "1.42 GB", format: "CBZ" },
    ],
    tags: ["剑戟", "武士", "完结", "硬派"],
    color: "from-accent-700 to-background-800",
  },
  {
    id: "mohuan-shitang",
    title: "魔幻食堂",
    author: "汤圆不吃汤圆",
    categories: ["搞笑", "奇幻"],
    status: "连载中",
    region: "国漫",
    year: 2025,
    updatedAt: "2026-10-11",
    views: 728000,
    follows: 55300,
    score: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20comedy%20manga%20cover%20of%20a%20tiny%20magical%20restaurant%20with%20a%20dragon%20chef%20serving%20glowing%20food%2C%20colorful%20floating%20spices%2C%20purple%20and%20orange%20magic%20sparkles%2C%20playful%20stylized%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-shitang&orientation=portrait",
    tagline: "本店只接受非人类顾客，人类的钱不收。",
    intro: "一家开在结界缝隙里的小食堂，客人有精灵、龙、幽灵和一位过劳的阎王。社恐厨师阿圆靠着一本会自己翻页的菜谱，勉强应付每天爆炸式的营业。沙雕笑点密集，偶尔会突然捅你一刀的类型。",
    chapters: 112,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "980 MB", format: "PDF" },
      { label: "章节合集 · 第 001-112 话", size: "612 MB", format: "CBZ" },
    ],
    tags: ["沙雕", "美食", "轻松", "奇幻日常"],
    color: "from-secondary-600 to-accent-600",
  },
  {
    id: "yongheng-de-xiatian",
    title: "永恒的夏天",
    author: "南风知我",
    categories: ["恋爱", "奇幻"],
    status: "连载中",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-17",
    views: 543000,
    follows: 42100,
    score: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20romance%20manga%20cover%20of%20a%20seaside%20town%20in%20endless%20summer%2C%20a%20girl%20in%20white%20dress%20holding%20a%20paper%20airplane%2C%20blooming%20hydrangea%2C%20warm%20golden%20light%20and%20violet%20clouds%2C%20soft%20painterly%20style%2C%20no%20text&width=600&height=840&seq=comic-cover-xiatian&orientation=portrait",
    tagline: "她被困在同一天里，而那天是他们的第一次见面。",
    intro: "海边小镇的八月十四日，已经重复了七年。只有少年周叙记得每一轮夏天的细节，而唯一能打破循环的女孩，却每次都会忘记他。以时间循环为骨架的恋爱长篇，每一话结尾都留一枚情绪钩子。",
    chapters: 42,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "520 MB", format: "PDF" },
      { label: "单话打包 · 第 001-042 话", size: "312 MB", format: "CBZ" },
    ],
    tags: ["时间循环", "青春", "海边", "国漫"],
    color: "from-accent-500 to-primary-600",
  },
  {
    id: "shenyou-baishu",
    title: "深幽白书",
    author: "四谷怪谈",
    categories: ["悬疑", "奇幻"],
    status: "连载中",
    region: "日本",
    year: 2024,
    updatedAt: "2026-10-09",
    views: 812000,
    follows: 61300,
    score: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Japanese%20horror%20folklore%20manga%20cover%20with%20a%20mysterious%20white%20fox%20mask%20floating%20above%20a%20shrine%20gate%2C%20red%20and%20deep%20purple%20ink%20textures%2C%20falling%20paper%20talismans%2C%20eerie%20atmosphere%2C%20refined%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-baishu&orientation=portrait",
    tagline: "记录下来的怪谈，第八天就会应验。",
    intro: "民俗学者九条在旧书摊买到一本会自己增页的白书，上面记载着尚未发生的怪异事件。她与不愿透露名字的神官一同追查每一条记录，却逐渐发现书页里出现了她自己的名字。氛围向恐怖与民俗考据结合的作品。",
    chapters: 88,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "1.12 GB", format: "PDF" },
      { label: "章节合集 · 第 001-088 话", size: "702 MB", format: "CBZ" },
    ],
    tags: ["怪谈", "民俗", "恐怖", "考据"],
    color: "from-primary-900 to-secondary-800",
  },
  {
    id: "chaojin-tuoli",
    title: "潮间脱离",
    author: "SEVEN",
    categories: ["科幻", "动作"],
    status: "连载中",
    region: "欧美",
    year: 2025,
    updatedAt: "2026-10-16",
    views: 689000,
    follows: 53800,
    score: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Cyberpunk%20graphic%20novel%20cover%20with%20a%20cyborg%20runner%20leaping%20across%20neon%20rooftops%2C%20tidal%20flood%20below%2C%20orange%20and%20magenta%20hologram%20lighting%2C%20bold%20ink%20and%20halftone%20texture%2C%20dynamic%20diagonal%20composition%2C%20no%20text&width=600&height=840&seq=comic-cover-chaojin&orientation=portrait",
    tagline: "海平面上升后的城市，只剩下屋顶之间的一条路。",
    intro: "全球水位上涨七十米后，城市变成了上下两层：水面上的新港，与水面下的旧城。信使“潮”在两层之间的缝隙里运送物品，直到接到一个必须亲自拆开的包裹。欧美硬派线条与赛博废土设定的混血作品。",
    chapters: 74,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "1.28 GB", format: "PDF" },
      { label: "单话打包 · 第 001-074 话", size: "806 MB", format: "CBZ" },
    ],
    tags: ["赛博朋克", "末日", "信使", "硬派"],
    color: "from-accent-600 to-background-800",
  },
  {
    id: "mao-yu-mianbao",
    title: "猫与面包店",
    author: "小林糖",
    categories: ["治愈", "搞笑"],
    status: "已完结",
    region: "日本",
    year: 2022,
    updatedAt: "2026-07-21",
    views: 493000,
    follows: 37600,
    score: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Charming%20slice%20of%20life%20manga%20cover%20of%20a%20quaint%20bakery%20with%20three%20cats%20sitting%20on%20the%20window%20sill%2C%20fresh%20bread%20and%20croissants%2C%20warm%20cream%20and%20peach%20tones%2C%20soft%20morning%20light%2C%20adorable%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-mao&orientation=portrait",
    tagline: "面包出炉的时候，猫会来排队。",
    intro: "小镇上面包店的老板娘和七只常驻猫之间的日常。每一话围绕一款面包展开，配上一段客人的小故事。全 60 话完结，书末附有真实可做的面包配方页。",
    chapters: 60,
    files: [
      { label: "完结全集 · 高清 PDF", size: "468 MB", format: "PDF" },
      { label: "完结全集 · 图片包", size: "298 MB", format: "CBZ" },
    ],
    tags: ["萌宠", "美食", "完结", "日常"],
    color: "from-accent-500 to-accent-800",
  },
  {
    id: "juedou-tianxia",
    title: "决斗天下",
    author: "铁线草",
    categories: ["热血", "奇幻"],
    status: "已完结",
    region: "国漫",
    year: 2023,
    updatedAt: "2026-06-18",
    views: 1345000,
    follows: 91600,
    score: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Epic%20chinese%20fantasy%20manga%20cover%20of%20two%20martial%20artists%20clashing%20on%20a%20floating%20mountain%20arena%2C%20sword%20aura%20in%20gold%20and%20violet%2C%20clouds%20and%20ancient%20temples%2C%20grand%20scale%20ink%20painting%20style%2C%20no%20text&width=600&height=840&seq=comic-cover-juedou&orientation=portrait",
    tagline: "天下第一的名号，每百年只留给活着的人。",
    intro: "每百年一次的“天下决”在浮空山开幕，八大世家与散修共同争夺唯一的名号。出身下九流的少年阿九带着一柄断剑登台，他要战胜的不只是对手，还有被世家写定的江湖规矩。完结篇 240 话，被誉为国漫热血题材里程碑。",
    chapters: 240,
    files: [
      { label: "完结全集 · 高清 PDF", size: "2.68 GB", format: "PDF" },
      { label: "完结全集 · 图片包", size: "1.88 GB", format: "CBZ" },
      { label: "外传与番外合集", size: "324 MB", format: "ZIP" },
    ],
    tags: ["武侠", "仙侠", "国漫", "完结"],
    color: "from-primary-600 to-accent-700",
  },
  {
    id: "yeban-diantai",
    title: "夜半电台",
    author: "午夜三点",
    categories: ["悬疑", "治愈"],
    status: "连载中",
    region: "韩国",
    year: 2025,
    updatedAt: "2026-10-13",
    views: 456000,
    follows: 34200,
    score: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Moody%20noir%20manga%20cover%20of%20a%20late%20night%20radio%20studio%20with%20glowing%20red%20on-air%20sign%2C%20headphones%20on%20a%20desk%2C%20rain%20on%20the%20window%2C%20city%20lights%20blurred%2C%20purple%20and%20amber%20tones%2C%20cinematic%2C%20no%20text&width=600&height=840&seq=comic-cover-diantai&orientation=portrait",
    tagline: "凌晨两点的来电，都来自已经不在的人。",
    intro: "独立电台主播京浩只在凌晨两点开播，听众永远不超过两位数。某天起，他接到的电话全部来自已经离世的人。他一边替他们传话，一边寻找那通打给自己的电话。悬疑外壳下的温柔故事。",
    chapters: 54,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "608 MB", format: "PDF" },
      { label: "单话打包 · 第 001-054 话", size: "386 MB", format: "CBZ" },
    ],
    tags: ["都市怪谈", "电台", "温柔", "韩国漫画"],
    color: "from-secondary-700 to-primary-800",
  },
  {
    id: "xingyuan-jianke",
    title: "星原剑客",
    author: "光年之外",
    categories: ["科幻", "热血"],
    status: "连载中",
    region: "日本",
    year: 2026,
    updatedAt: "2026-10-17",
    views: 704000,
    follows: 51200,
    score: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Space%20opera%20anime%20manga%20cover%20of%20a%20swordsman%20in%20a%20sleek%20suit%20standing%20on%20a%20starship%20deck%2C%20nebula%20and%20distant%20ringed%20planet%20behind%2C%20violet%20and%20orange%20light%20beams%2C%20glowing%20energy%20blade%2C%20dramatic%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-xingyuan&orientation=portrait",
    tagline: "在星际航行的时代，剑术依然决定谁站着离开。",
    intro: "星际联邦禁止近身战，却有一支被遗忘的剑士队伍驻守在边境荒星。新人剑客鹭原加入后，发现这支队伍的真正任务是守住一扇不该被打开的门。宇宙尺度世界观搭配硬朗的刀剑对决，是本季最受期待的新连载。",
    chapters: 38,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "498 MB", format: "PDF" },
      { label: "单话打包 · 第 001-038 话", size: "296 MB", format: "CBZ" },
    ],
    tags: ["太空歌剧", "剑术", "边境", "新连载"],
    color: "from-primary-700 to-secondary-600",
  },
  {
    id: "quanneng-banzhang",
    title: "全能班长",
    author: "林间小路",
    categories: ["搞笑", "恋爱"],
    status: "连载中",
    region: "国漫",
    year: 2024,
    updatedAt: "2026-10-10",
    views: 587000,
    follows: 43900,
    score: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cheerful%20school%20comedy%20manga%20cover%20of%20a%20confident%20student%20council%20president%20holding%20a%20megaphone%2C%20chaotic%20classroom%20with%20flying%20papers%2C%20bright%20orange%20and%20violet%20color%20blocks%2C%20playful%20stylized%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-banzhang&orientation=portrait",
    tagline: "她什么都能搞定，除了坐在后排的那个男生。",
    intro: "高二一班班长苏麦是全校公认的“全能选手”，成绩、运动、组织力全满。唯一解决不了的，是那个每天上课睡觉、却总能考第一的同桌。校园搞笑与青涩恋爱的双线推进，轻松又上头。",
    chapters: 96,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "842 MB", format: "PDF" },
      { label: "章节合集 · 第 001-096 话", size: "532 MB", format: "CBZ" },
    ],
    tags: ["校园", "搞笑", "青春", "国漫"],
    color: "from-accent-500 to-secondary-500",
  },
  {
    id: "huangye-xiake",
    title: "荒野侠客",
    author: "风滚草",
    categories: ["动作", "科幻"],
    status: "连载中",
    region: "欧美",
    year: 2025,
    updatedAt: "2026-10-08",
    views: 402000,
    follows: 31400,
    score: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20western%20comic%20cover%20of%20a%20lone%20rider%20on%20a%20mechanical%20horse%20crossing%20a%20dusty%20desert%20highway%2C%20ruined%20billboards%2C%20orange%20dust%20storm%20and%20violet%20sky%2C%20bold%20graphic%20style%2C%20no%20text&width=600&height=840&seq=comic-cover-huangye&orientation=portrait",
    tagline: "在废土上，最快的枪和最快的腿一样值钱。",
    intro: "文明崩塌后的第四十年，公路取代了国家，赏金取代了法律。独行侠客带着一台改装机械马穿越大漠，只为把一枚芯片送到最后的服务器。硬派分镜与废土美学的结合。",
    chapters: 62,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "716 MB", format: "PDF" },
      { label: "单话打包 · 第 001-062 话", size: "448 MB", format: "CBZ" },
    ],
    tags: ["废土", "西部", "赏金猎人", "欧美"],
    color: "from-accent-700 to-background-800",
  },
  {
    id: "qiuqiu-maoxian",
    title: "秋秋的猫仙冒险",
    author: "喵喵茶",
    categories: ["奇幻", "治愈"],
    status: "连载中",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-16",
    views: 318000,
    follows: 26500,
    score: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20cover%20of%20a%20cute%20white%20cat%20spirit%20wearing%20a%20tiny%20red%20scarf%2C%20walking%20through%20a%20glowing%20enchanted%20forest%20with%20floating%20lanterns%2C%20magical%20violet%20fireflies%20and%20warm%20orange%20light%2C%20charming%20illustration%2C%20no%20text&width=600&height=840&seq=comic-cover-qiuqiu&orientation=portrait",
    tagline: "一只猫仙，一只布偶熊，去还一封迟到了一百年的信。",
    intro: "猫仙秋秋为了偿还主人生前的一句承诺，带着一只不会说话的布偶熊踏上旅程。路上遇到风铃精、纸灯妖和一位迷路的邮差。温柔奇幻风格，画风治愈，适合全年龄阅读。",
    chapters: 34,
    files: [
      { label: "全卷合集 · 高清 PDF", size: "436 MB", format: "PDF" },
      { label: "单话打包 · 第 001-034 话", size: "268 MB", format: "CBZ" },
    ],
    tags: ["猫仙", "冒险", "全年龄", "国漫"],
    color: "from-secondary-500 to-accent-600",
  },
];

export const HOT_LIST = [...COMICS].sort((a, b) => b.views - a.views).slice(0, 6);

export const SLIDES = [COMICS[0], COMICS[2], COMICS[3], COMICS[5], COMICS[13]];

export const FAQS = [
  {
    q: "禁漫天堂的资源是免费的吗？",
    a: "平台聚合展示漫画作品的基础信息与资源索引，浏览、搜索、分类筛选完全免费。当前演示版本中的下载按钮为功能展示，实际文件分发链路会在后续版本接入。",
  },
  {
    q: "为什么点击下载按钮只弹出了提示？",
    a: "现阶段站点使用本地演示数据运行，下载与分享交互仅用于展示页面效果，提示“功能演示，待接入”，不会真实触发文件传输。",
  },
  {
    q: "如何快速找到想看的漫画？",
    a: "推荐三种方式：一是首页顶部搜索框直接输入关键词；二是通过分类快捷入口按题材浏览；三是在分类页使用状态、地区、年份与排序组合筛选。",
  },
  {
    q: "更新频率是怎样的？",
    a: "热门连载作品通常在工作日晚间更新，已完结作品会陆续补齐合集与画集附录。列表页按更新时间排序即可查看最新上线内容。",
  },
  {
    q: "可以在手机上使用吗？",
    a: "支持。全站为响应式设计，移动端导航收起为汉堡菜单，筛选面板改为弹出式，卡片自动转为单列，按钮与链接均按触屏友好尺寸设计。",
  },
];